import { type Node } from '@xyflow/react'

export const SIZES = {
  NODE_WIDTH: 50,
  VERTICAL_SPACING: 150,
  HORIZONTAL_SPACING: 0,
  TREE_WIDTH: 220,
  TREE_HEIGHT: 150,
}

export type CustomNode = Node<{
  expanded: boolean
  expandable?: boolean
  label: string
  name: string
  type: string
  description: string
  id: number
  node_uuid: string
  childrenCount: number
}>

export interface SerializedTreeNode {
  id: number
  node_uuid: string
  type: string
  ancestor_id: number | null
  name: string
  description: string | null
  children: SerializedTreeNode[]
}
